var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
/** Um segmento na lista do formulario. */
let SegmentOptionScope = class SegmentOptionScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.value = '';
        this.current = false;
        this.onSelect = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], SegmentOptionScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SegmentOptionScope.prototype, "value", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SegmentOptionScope.prototype, "current", void 0);
SegmentOptionScope = __decorate([
    Observable
], SegmentOptionScope);
export { SegmentOptionScope };
/**
 * O formulario de empresa.
 *
 * `onClose` nao e opcional: o shell recusa um scope de dialogo sem ele, porque um
 * dialogo que nao sabe se fechar prende o leitor.
 */
let CompanyEditScope = class CompanyEditScope extends Scope {
    constructor() {
        super(...arguments);
        this.title = '';
        this.creating = true;
        this.busy = false;
        /** A empresa ainda vem do servidor: o formulario nao pode ser salvo vazio por cima dela. */
        this.loading = false;
        /**
         * Conta as escritas PROGRAMATICAS nos campos - o mesmo contador de Meus dados.
         *
         * Os campos sao nao controlados (mascara em campo controlado por scope come
         * tecla digitada), e campo nao controlado ignora mudanca de `defaultValue`.
         * Amarrar o `key` ao VALOR nao resolve: digitar redesenha, o valor muda a chave,
         * o campo remonta a cada tecla e sobra a primeira letra.
         */
        this.formRevision = 0;
        this.cnpj = '';
        this.razaoSocial = '';
        this.nomeFantasia = '';
        this.ramoAtividade = '';
        this.contactName = '';
        /** So no CADASTRO: informado, o administrador nasce com CPF de gente. */
        this.contactCpf = '';
        this.contactPhone = '';
        this.contactEmail = '';
        /**
         * Segmento e colaboradores contratados: a classificacao que o ICP usa.
         *
         * So o administrador geral ve - e o unico papel cujos dois campos o servidor grava.
         */
        this.icpEditable = false;
        this.segments = [];
        this.segmentSummary = '';
        /** O X so existe enquanto nao ha segmento GRAVADO: nulo, para o servidor, e "nao altera". */
        this.segmentClearable = true;
        /** Texto, como os outros campos: o numero e conferido ao salvar. */
        this.contractedHeadcount = '';
        this.onCnpjChanged = Scope.SYNC_ACTION_STRING;
        this.onRazaoSocialChanged = Scope.SYNC_ACTION_STRING;
        this.onNomeFantasiaChanged = Scope.SYNC_ACTION_STRING;
        this.onRamoAtividadeChanged = Scope.SYNC_ACTION_STRING;
        this.onContactNameChanged = Scope.SYNC_ACTION_STRING;
        this.onContactCpfChanged = Scope.SYNC_ACTION_STRING;
        this.onContactPhoneChanged = Scope.SYNC_ACTION_STRING;
        this.onContactEmailChanged = Scope.SYNC_ACTION_STRING;
        this.onContractedHeadcountChanged = Scope.SYNC_ACTION_STRING;
        this.onClearSegment = Scope.ASYNC_ACTION;
        this.onSave = Scope.ASYNC_ACTION;
        this.onClose = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyEditScope.prototype, "title", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyEditScope.prototype, "creating", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyEditScope.prototype, "busy", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyEditScope.prototype, "loading", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyEditScope.prototype, "formRevision", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyEditScope.prototype, "cnpj", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyEditScope.prototype, "razaoSocial", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyEditScope.prototype, "nomeFantasia", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyEditScope.prototype, "ramoAtividade", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyEditScope.prototype, "contactName", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyEditScope.prototype, "contactCpf", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyEditScope.prototype, "contactPhone", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyEditScope.prototype, "contactEmail", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyEditScope.prototype, "icpEditable", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], CompanyEditScope.prototype, "segments", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyEditScope.prototype, "segmentSummary", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyEditScope.prototype, "segmentClearable", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyEditScope.prototype, "contractedHeadcount", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyEditScope.prototype, "cnpjError", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyEditScope.prototype, "razaoSocialError", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyEditScope.prototype, "contactNameError", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyEditScope.prototype, "contactCpfError", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyEditScope.prototype, "contactPhoneError", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyEditScope.prototype, "contactEmailError", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyEditScope.prototype, "contractedHeadcountError", void 0);
CompanyEditScope = __decorate([
    Observable
], CompanyEditScope);
export { CompanyEditScope };
//# sourceMappingURL=company-edit.scope.js.map